import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createEmissionTarget,
  deleteEmissionTarget,
  getEmissionTargets,
  updateEmissionTarget,
  type CreateOrUpdateEmissionTargetRequest,
  type EmissionTarget,
} from "api";
import { QUERY_KEYS } from "consts";

export const useEmissionTargets = () =>
  useQuery<EmissionTarget[]>({
    queryKey: [QUERY_KEYS.EMISSION_TARGETS],
    queryFn: getEmissionTargets,
  });

export const useCreateEmissionTarget = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateOrUpdateEmissionTargetRequest) =>
      createEmissionTarget(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.EMISSION_TARGETS] });
    },
  });
};

export const useUpdateEmissionTarget = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      body,
    }: {
      id: number;
      body: CreateOrUpdateEmissionTargetRequest;
    }) => updateEmissionTarget(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.EMISSION_TARGETS] });
    },
  });
};

export const useDeleteEmissionTarget = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteEmissionTarget(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.EMISSION_TARGETS] });
    },
  });
};
